module.exports = __webpack_public_path__ + "fonts/brand-icons.e8c322de.e8c322de.woff2";